/* YELM editorial sections (30 Sep 2026). Loaded by every yelm-ed-* section.
   Safe to load more than once: the second load just re-runs init. */
(function () {
  if (window.YelmEd) { window.YelmEd.init(document); return; }

  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var io = null;

  /* Reveal on scroll. Skipped in the theme editor and without IntersectionObserver. */
  function reveal(scope) {
    if (inEditor || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    scope.querySelectorAll('.ye').forEach(function (sec) { sec.classList.add('ye--anim'); });
    scope.querySelectorAll('.ye-reveal:not([data-ye-obs])').forEach(function (el) {
      el.setAttribute('data-ye-obs', '');
      io.observe(el);
    });
  }

  /* Hero video: load only the file for the current breakpoint, respect reduced motion
     and Save-Data, pause off-screen, and let the visitor pause it (WCAG 2.2.2). */
  function heroVideo(hero) {
    if (hero.dataset.init === '1') return;
    var v = hero.querySelector('video');
    if (!v) return;
    hero.dataset.init = '1';
    var btn = hero.querySelector('[data-ye-video-toggle]');
    var mq = window.matchMedia('(max-width: 899px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    var hasPoster = hero.hasAttribute('data-poster');
    var want = !(reduce || saveData);
    var visible = true;
    var pick = function () { return (mq.matches && v.dataset.srcM) ? v.dataset.srcM : v.dataset.srcD; };
    var load = function () {
      var src = pick();
      if (src && v.getAttribute('src') !== src) { v.setAttribute('src', src); v.load(); }
    };
    var sync = function () {
      if (!btn) return;
      btn.classList.toggle('is-paused', v.paused);
      btn.setAttribute('aria-label', v.paused ? btn.dataset.play : btn.dataset.pause);
    };
    var play = function () {
      load();
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(sync);
    };
    v.addEventListener('playing', function () { v.classList.add('is-playing'); sync(); });
    v.addEventListener('pause', sync);
    if (!hasPoster) v.addEventListener('loadeddata', function () { v.classList.add('is-playing'); });
    if (btn) btn.addEventListener('click', function () {
      if (v.paused) { want = true; play(); } else { want = false; v.pause(); }
    });
    if (!want && !hasPoster) { v.preload = 'metadata'; load(); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (!visible && !v.paused) v.pause();
        else if (visible && want) play();
      }).observe(hero);
    } else if (want) {
      play();
    }
    var onBreakpoint = function () {
      if (!v.getAttribute('src')) return;
      load();
      if (want && visible) play();
    };
    if (mq.addEventListener) mq.addEventListener('change', onBreakpoint);
    else if (mq.addListener) mq.addListener(onBreakpoint);
    sync();
  }

  /* Transparent header: when a hero is the first section on the page, pull it up so the
     media starts directly under the utility bar instead of leaving a gap. */
  function fitHeader() {
    var header = document.querySelector('[data-transparent-header="true"]');
    document.querySelectorAll('.ye--hero').forEach(function (el) {
      var sec = el.closest('.shopify-section');
      if (!sec || document.body.classList.contains('header-stuck')) return;
      sec.style.marginTop = '0px';
      if (!header || sec.previousElementSibling) return;
      var gap = sec.getBoundingClientRect().top - header.getBoundingClientRect().top;
      if (gap > 0) sec.style.marginTop = (-gap) + 'px';
    });
  }

  /* Swipe galleries on mobile: dots under the row show position and that it scrolls. */
  function galleryDots(gal) {
    if (gal.dataset.dots === '1') return;
    var figs = gal.querySelectorAll('figure');
    var dots = gal.parentNode.querySelector('.ye-gal__dots');
    if (!dots || figs.length < 2) return;
    gal.dataset.dots = '1';
    dots.innerHTML = '';
    figs.forEach(function () { dots.appendChild(document.createElement('span')); });
    var spans = dots.querySelectorAll('span');
    var update = function () {
      var step = figs[1].offsetLeft - figs[0].offsetLeft || 1;
      var i = Math.round(gal.scrollLeft / step);
      if (gal.scrollLeft + gal.clientWidth >= gal.scrollWidth - 4) i = figs.length - 1;
      spans.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
    };
    gal.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init(scope) {
    scope = scope || document;
    reveal(scope);
    scope.querySelectorAll('.ye-gal--swipe-m').forEach(galleryDots);
    scope.querySelectorAll('[data-ye-hero-video]').forEach(heroVideo);
    fitHeader();
  }

  window.YelmEd = { init: init };

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('load', fitHeader);
  window.addEventListener('resize', fitHeader);

  /* Clarity: which link in an editorial section gets the click */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ye a');
    if (!a || typeof window.clarity !== 'function') return;
    var sec = a.closest('.ye');
    window.clarity('event', 'ye_click');
    window.clarity('set', 'ye_click_section', (sec && sec.getAttribute('data-ye-type')) || '');
    window.clarity('set', 'ye_click_target', (a.textContent || a.getAttribute('href') || '').trim().slice(0, 40));
  });

  init(document);
})();
